export default __webpack_public_path__ + "static/media/2023-IMcover.02bd0079.png";